// extracted by mini-css-extract-plugin
export default {"container":"Cl-z","blurb":"Dl-z","links":"El-z"};